import { colors } from '@mm/utils';
import classNames from 'classnames';
import React from 'react';
import { Circle } from '../Circle/Circle';
import './Status.pcss';

export type KnownStatusType =
  | 'sent'
  | 'active'
  | 'inactive'
  | 'ended'
  | 'draft'
  | 'delivered'
  | 'sending'
  | 'queued'
  | 'canceled'
  | 'paused'
  | 'failed'
  | 'synced'
  | 'published'
  | 'connected manually';

type Props = {
  className?: string;
  status?: KnownStatusType | React.ReactNode;
  color?: string;
  pulsing?: boolean;
  noCapitalize?: boolean;
  indicatorSizePx?: number;
  css?: {
    statusIndicator?: string;
  };
};

const getColorByStatus = (status: string) => {
  const statusColorMap: Record<KnownStatusType, string> = {
    sent: colors.accentBlue,
    active: colors.green6,
    inactive: colors.grayLight,
    ended: colors.accentBlue,
    draft: colors.grayLight,
    delivered: colors.accentBlue,
    sending: colors.green,
    queued: colors.orange,
    canceled: colors.accentBlue,
    paused: colors.orange,
    failed: colors.red,
    synced: colors.blue,
    published: colors.blue,
    'connected manually': colors.blue,
  };
  return statusColorMap[String(status).toLocaleLowerCase()];
};

export const Status = ({
  className,
  status,
  color,
  pulsing,
  noCapitalize,
  css,
  indicatorSizePx = 10,
}: Props) => {
  const circleColor = color
    ? color
    : status && typeof status === 'string' && getColorByStatus(status);
  return (
    <div
      className={classNames(className, 'c-status', {
        'c-status--no-capitalize': noCapitalize,
      })}
    >
      <Circle
        size={indicatorSizePx}
        className={classNames(
          'c-status-indicator',
          {
            'c-status-indicator--pulsing': pulsing,
          },
          css?.statusIndicator,
        )}
        color={circleColor}
      />
      {status || 'Status unknown'}
    </div>
  );
};
